import React from "react";
import Iframe from "react-iframe";
import * as S from "./styles";

function Card(props) {
  const { title, url, height, full, expand } = props;

  return (
    <S.Wrapper full={full}>
      <S.Title>{title}</S.Title>
      <Iframe
        url={url}
        width="100%"
        height={expand ? window.innerHeight - 100 : height || 450}
        display="initial"
        position="relative"
        frameBorder="0"
      />
    </S.Wrapper>
  );
}

export default Card;
